<div class="modal fade modal"
  id="modal" tabindex="-1" role="dialog" aria-hidden="true"
  data-backdrop="static"
  [ngClass]="{'modal-error': content.typeModal === 'modal-error', 'modal-confirm': content.typeModal === 'modal-confirm'}">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content p-2">
      <div class="modal-body">
        @if (content.closeButton) {
          <button type="button" class="close mdc-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" class="text-white">&times;</span>
          </button>
        }
        <div class="row d-flex  h-100">
          @if (content.imgLateral) {
            <div class="d-block d-lg-none offset-3 col-6 text-center">
              <img src="{{content.imgLateral}}" class="icon" alt="Validacion exitosa">
            </div>
          }
          <div class="col-12 col-lg-6 my-2 p-0 p-lg-5 text-center justify-content-center align-self-center">
            <div class="title my-2">
              {{ content.titulo }}
            </div>
            <div class="txt p-2">
              <p  [innerHTML]="content.textoHTML">
              </p>
            </div>
            <br>

              @if ((content.typeModal === 'modal-confirm') && (content.textBoton) && (!content.enlaceBoton)) {
                <button
                  class=" btn-lg btn text-center d-block m-auto btn-primary mt-5"
                  data-dismiss="modal">{{ content.textBoton }} <i class="arrow right"></i></button>
                }

                @if ((content.typeModal === 'modal-error') && (content.textBoton) && (!content.enlaceBoton)) {
                  <button
                    class="btn-lg btn text-center d-block m-auto btn-error mt-5 text-white"
                    data-dismiss="modal">{{ content.textBoton }} <i class="arrow right"></i></button>
                  }

                  @if ((content.typeModal === 'modal-error') && (content.enlaceBoton)) {
                    <a
                      href="{{content.enlaceBoton}}"
                      class="btn-lg btn text-center d-block m-auto btn-error mt-5 text-white">
                      {{ content.textBoton }}
                      <i class="arrow right"></i>
                    </a>
                  }

                  @if ((content.typeModal === 'modal-confirm') && (content.enlaceBoton)) {
                    <a
                      href="{{content.enlaceBoton}}"
                      class="btn-lg btn text-center d-block m-auto btn-primary mt-5 text-white">
                      {{ content.textBoton }}
                      <i class="arrow right"></i>
                    </a>
                  }

                  @if ((content.typeModal === 'modal-pass') && (content.enlaceBoton)) {
                    <a data-dismiss="modal" class="btn-lg btn text-center d-block m-auto btn-primary mt-5 text-white" (click)="sesion.navigateToRoute(contenido.info.login.urlremember)">
                      {{ content.textBoton }}
                      <i class="arrow right"></i>
                    </a>
                  }

                  @if (content.enlace2texto) {
                    <a
                      (click)="content.close()"
                      class="text-center d-block m-auto pt-2 link" style="cursor: pointer;">
                      {{ content.enlace2texto }}
                    </a>
                  }
                </div>
                @if (content.imgLateral) {
                  <div class="d-none d-lg-block col-lg-6 p-5 justify-content-center align-self-center text-right">
                    <img src="{{content.imgLateral}}" class="icon" alt="Validacion exitosa">
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>